import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import Select, { createFilter } from "react-select";
import { API_URL, API_URL_sedes } from "../../constants";

import { getAuthHeaders } from "../../utils/auth";
class NewClientForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sedes: [],          // array of {id, sede}
      sede: "",           // will hold the selected sede ID (number or string)
      pk: "",
      client_code: "",    // 🔹 system-managed, hidden from user
      razon_social: "",
      id_fiscal: "",
      nombre: "",
      giro: "",
      nombre_comprador: "",
      nombre_admin: "",
      email: "",
      phone: "",
      pais: "",
      codigo_postal: "",
      estado: "",
      ciudad: "",
      calle: "",
      status: "Activo",
      errorMessage: "",
      validationErrors: {},
      isSubmitting: false,
    };
  }

  componentDidMount() {
    if (this.props.client) {
      const c = this.props.client;

      // 🔑 Safely derive PK from either pk or id
      const pkValue = c.pk ?? c.id ?? "";

      const {
        razon_social,
        id_fiscal,
        nombre,
        giro,
        sede,               // VS
        nombre_comprador,
        nombre_admin,
        email,
        phone,
        pais,
        codigo_postal,
        estado,
        ciudad,
        calle,
        status,
        client_code,
      } = c;

      this.setState({
        pk: pkValue,
        client_code: client_code ?? "",      // 🔹 keep existing code in state
        razon_social: razon_social ?? "",
        id_fiscal: id_fiscal ?? "",
        nombre: nombre ?? "",
        giro: giro ?? "",
        sede: typeof sede === "object" && sede !== null ? sede.id : (sede ?? ""),
        nombre_comprador: nombre_comprador ?? "",
        nombre_admin: nombre_admin ?? "",
        email: email ?? "",
        phone: phone ?? "",
        pais: pais ?? "",
        codigo_postal: codigo_postal ?? "",
        estado: estado ?? "",
        ciudad: ciudad ?? "",
        calle: calle ?? "",
        status: status ?? "Activo",
      });
    }

    const headers = getAuthHeaders();

    axios
      .get(API_URL_sedes, { headers, validateStatus: (s) => s < 600 })
      .then((response) => {
        if (response.status >= 400) {
          console.error("GET sedes failed:", response.status, response.data);
          this.setState({ errorMessage: "Error fetching Sedes." });
          return;
        }
        this.setState({ sedes: Array.isArray(response.data) ? response.data : [] });
        console.log("Fetched sedes:", this.state.sedes);
      })
      .catch((error) => {
        console.error("Error fetching Sedes:", this._formatAxiosError(error));
        this.setState({ errorMessage: "Error fetching Sedes." });
      });
  }

  _formatAxiosError = (err) => {
    const r = err?.response;
    return {
      code: err?.code,
      status: r?.status,
      url: r?.config?.url,
      method: r?.config?.method,
      contentType: r?.headers?.["content-type"],
      snippet: typeof r?.data === "string" ? r.data.slice(0, 800) : r?.data,
    };
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSedeChange = (e) => {
    this.setState({ sede: e.target.value });
  };

  handleGiroChange = (e) => {
    this.setState({ giro: e.target.value });
  };

  // VALIDATION
  validateForm = () => {
    const errors = {};
    const { razon_social, id_fiscal, nombre } = this.state;

    if (!razon_social || razon_social.trim() === '') {
      errors.razon_social = 'Por favor ingresa la razón social';
    }

    if (!id_fiscal || id_fiscal.trim() === '') {
      errors.id_fiscal = 'Por favor ingresa el ID fiscal';
    }

    if (!nombre || nombre.trim() === '') {
      errors.nombre = 'Por favor ingresa el nombre comercial';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  // Only send fields your API expects (except client_code, added only on edit)
  _buildPayload = () => {
    const {
      razon_social,
      id_fiscal,
      nombre,
      giro,
      sede,
      nombre_comprador,
      nombre_admin,
      email,
      phone,
      pais,
      codigo_postal,
      estado,
      ciudad,
      calle,
      status,
    } = this.state;

    return {
      razon_social,
      id_fiscal,
      nombre,
      giro,
      sede, // must be the ID your backend expects
      nombre_comprador,
      nombre_admin,
      email,
      phone,
      pais,
      codigo_postal,
      estado,
      ciudad,
      calle,
      status,
    };
  };

  createClient = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      // Focus first invalid field
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();

    const payload = this._buildPayload(); // 🔹 no client_code: backend generates it

    axios
      .post(API_URL, payload, {
        headers,
        validateStatus: (s) => s < 600,
        transformResponse: [(data) => data], // don't auto-parse so we can log HTML
      })
      .then((res) => {
        if (res.status >= 400) {
          console.error(
            "Create client failed:",
            res.status,
            res.headers["content-type"],
            typeof res.data === "string" ? res.data.slice(0, 800) : res.data
          );
          this.setState({
            errorMessage: "Error al crear el cliente. Por favor verifica los datos.",
            isSubmitting: false
          });
          return;
        }
        this.props.resetState?.();
        this.props.toggle?.();
      })
      .catch((error) => {
        console.error("Error adding cliente:", this._formatAxiosError(error));
        this.setState({
          errorMessage: "Error de conexión. Por favor intenta nuevamente.",
          isSubmitting: false
        });
      });
  };

  editClient = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      // Focus first invalid field
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    const { pk } = this.state;

    if (!pk) {
      console.error("Edit client called without a valid pk in state.", { pk });
      this.setState({
        errorMessage: "No se pudo identificar el cliente a actualizar (pk faltante).",
      });
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();

    const basePayload = this._buildPayload();

    // 🔹 Ensure we always send the existing client_code back on update
    const client_code =
      this.state.client_code ||
      (this.props.client && this.props.client.client_code) ||
      "";

    const payload = { ...basePayload, client_code };

    // ensure trailing slash for DRF default routers
    const base = String(API_URL);
    const url = base.endsWith("/") ? `${base}${pk}/` : `${base}/${pk}/`;

    axios
      .put(url, payload, {
        headers,
        validateStatus: (s) => s < 600,
        transformResponse: [(data) => data],
      })
      .then((res) => {
        if (res.status >= 400) {
          console.error(
            "Update client failed:",
            res.status,
            res.headers["content-type"],
            typeof res.data === "string" ? res.data.slice(0, 800) : res.data
          );
          this.setState({
            errorMessage: "Error actualizando el cliente. Por favor verifica los datos.",
            isSubmitting: false
          });
          return;
        }
        this.props.resetState?.();
        this.props.toggle?.();
      })
      .catch((error) => {
        console.error("Error updating client:", this._formatAxiosError(error));
        this.setState({
          errorMessage: "Error de conexión. Por favor intenta nuevamente.",
          isSubmitting: false
        });
      });
  };

  defaultIfEmpty = (value) => {
    return value === "" ? "" : value;
  };

  render() {
    const { errorMessage, sede, sedes, giro, status, validationErrors, isSubmitting } = this.state;

    // Filter option for react-select
    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    // Options for Select components
    const giroOptions = [
      { value: "Manufactura", label: "Manufactura" },
      { value: "Servicios", label: "Servicios" },
      { value: "Logística", label: "Logística" },
      { value: "Healthcare", label: "Healthcare" },
      { value: "Agricultura", label: "Agricultura" },
      { value: "Construcción", label: "Construcción" },
      { value: "Gobierno", label: "Gobierno" },
      { value: "Bancos", label: "Bancos" },
      { value: "Otro", label: "Otro" },
    ];

    const sedeOptions = Array.isArray(sedes)
      ? sedes.map(s => ({ value: s.id, label: s.sede }))
      : [];

    const statusOptions = [
      { value: "Activo", label: "Activo" },
      { value: "Inactivo", label: "Inactivo" },
      { value: "Prospecto", label: "Prospecto" },
    ];

    return (
      <Form onSubmit={this.props.client ? this.editClient : this.createClient}>
        {/* Info Note */}
        <p style={{ fontSize: '0.9em', color: '#007bff', marginBottom: '1rem' }}>
          Los campos marcados con <span style={{ color: 'red' }}>*</span> son obligatorios
        </p>

        <FormGroup>
          <Label for="razon_social">Razon Social: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="razon_social"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.razon_social)}
            invalid={!!validationErrors.razon_social}
          />
          {validationErrors.razon_social && (
            <div className="invalid-feedback d-block">{validationErrors.razon_social}</div>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="id_fiscal">Id Fiscal: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="id_fiscal"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.id_fiscal)}
            invalid={!!validationErrors.id_fiscal}
          />
          {validationErrors.id_fiscal && (
            <div className="invalid-feedback d-block">{validationErrors.id_fiscal}</div>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="nombre">Nombre Comercial: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="nombre"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.nombre)}
            invalid={!!validationErrors.nombre}
          />
          {validationErrors.nombre && (
            <div className="invalid-feedback d-block">{validationErrors.nombre}</div>
          )}
        </FormGroup>

        <FormGroup>
          <Label for="giro">Giro:</Label>
          <Select
            options={giroOptions}
            value={giroOptions.find((o) => o.value === giro) || null}
            onChange={(opt) => this.handleGiroChange({ target: { name: 'giro', value: opt ? opt.value : "" }})}
            placeholder="Selecciona Giro"
            isClearable
            filterOption={filterOption}
          />
        </FormGroup>

        <FormGroup>
          <Label for="sede">Selecciona VS</Label>
          <Select
            options={sedeOptions}
            value={sedeOptions.find((o) => o.value == sede) || null}
            onChange={(opt) => this.handleSedeChange({ target: { name: 'sede', value: opt ? opt.value : "" }})}
            placeholder="Selecciona Value Stream"
            isClearable
            filterOption={filterOption}
          />
        </FormGroup>

        <FormGroup>
          <Label for="status">Status:</Label>
          <Select
            options={statusOptions}
            value={statusOptions.find((o) => o.value === status) || null}
            onChange={(opt) => this.onChange({ target: { name: 'status', value: opt ? opt.value : "" }})}
            placeholder="Selecciona status"
            isClearable
            filterOption={filterOption}
          />
        </FormGroup>

        <FormGroup>
          <Label for="nombre_comprador">Nombre Comprador:</Label>
          <Input
            type="text"
            name="nombre_comprador"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.nombre_comprador)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="nombre_admin">Nombre C x P:</Label>
          <Input
            type="text"
            name="nombre_admin"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.nombre_admin)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="email">Correo:</Label>
          <Input
            type="email"
            name="email"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.email)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="phone">Telefono:</Label>
          <Input
            type="text"
            name="phone"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.phone)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="pais">Pais:</Label>
          <Input
            type="text"
            name="pais"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.pais)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="codigo_postal">Codigo Postal:</Label>
          <Input
            type="text"
            name="codigo_postal"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.codigo_postal)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="estado">Estado:</Label>
          <Input
            type="text"
            name="estado"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.estado)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="ciudad">Ciudad:</Label>
          <Input
            type="text"
            name="ciudad"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.ciudad)}
          />
        </FormGroup>

        <FormGroup>
          <Label for="calle">Calle y Numero:</Label>
          <Input
            type="text"
            name="calle"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.calle)}
          />
        </FormGroup>

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
        <Button color="primary" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="me-2" /> Guardando...
            </>
          ) : (
            this.props.client ? "Actualizar Cliente" : "Crear Cliente"
          )}
        </Button>
      </Form>
    );
  }
}

export default NewClientForm;
